// CompanyModal.styles.ts
import styled from "styled-components";
import { ate } from "../../../global/breakpoints";

// ===== INTERFACE DO TEMA =====
interface Theme {
  colors: {
    background: string;
    text: string;
    selection: string;
    modalColor: string;
    border: string;
    primary?: string;
    danger?: string;
    selectionDark?: string;
    textOnPrimary?: string;
    label?: string;
    borderColor?: string;
  };
}

// ===== COMPONENTES DE MODAL =====
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* A gaveta encosta no pe' da tela: o alinhamento deixa de ser central. */
  ${ate.tablet} {
    align-items: flex-end;
  }
`;

export const ModalContent = styled.div<{ large?: boolean; medium?: boolean }>`
  background: ${(props) => props.theme.colors.modalColor || "#fff"};
  padding: var(--sp-24);
  border-radius: 12px;
  width: ${(props) => (props.large ? "95%" : props.medium ? "80%" : "60%")};
  max-width: ${(props) =>
    props.large ? "calc(var(--u) * 1400)" : props.medium ? "calc(var(--u) * 1000)" : "calc(var(--u) * 800)"};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-20px);
  animation: slideIn 0.3s ease forwards;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /*
   * NO CELULAR ESTA CAIXA VIRA GAVETA — e nao e' preferencia, e' conserto.
   *
   * Com "width: 60%" um modal normal tem 225px num telefone de 375: dois
   * campos lado a lado nao cabem, e o titulo quebra em cinco linhas. O
   * "large" (95%) chega perto da largura toda mas continua centrado na
   * vertical, com as bordas arredondadas cortadas pelo topo e pelo pe' da
   * tela.
   *
   * A gaveta de baixo resolve os dois: ocupa a largura inteira, encosta no pe'
   * da tela (que e' onde o polegar esta') e so' arredonda em cima, que e' a
   * unica borda que aparece.
   *
   * O 100dvh CONTRA 100vh, que veio de um defeito MEDIDO no FlyOps.
   *
   * Relato da operacao la', em 24/08/2026: "nao consigo clicar na renuncia do
   * seguro flex no mobile, nao deixa puxar mais". A gaveta usava 100vh — e no
   * celular 100vh e' a viewport GRANDE, a que inclui a faixa coberta pela
   * barra do navegador. A gaveta ficava mais alta que a area visivel, o rodape
   * grudava no fim dela (fora da tela) e a rolagem interna terminava sem nunca
   * revelar os botoes. O 100dvh acompanha a altura realmente visivel.
   *
   * Aqui o vh de cima e' "max-height: 90vh", com o mesmo defeito: os botoes de
   * Salvar e Cancelar caem atras da barra do navegador. Sao 92dvh porque a
   * sobra de 8% mostra o escuro do overlay em cima e deixa claro que da' para
   * fechar tocando fora.
   *
   * NADA DISTO MUDA A TELA GRANDE. A trava do gabarito visual exige diferenca
   * ZERO em 1440px, e uma media query de max-width 768 nunca chega la'.
   */
  ${ate.tablet} {
    width: 100%;
    max-width: 100%;
    max-height: 92dvh;
    margin-top: auto;
    padding: var(--sp-16);
    border-radius: 16px 16px 0 0;
    animation: subirGaveta 0.28s ease forwards;
  }

  @keyframes subirGaveta {
    from {
      transform: translateY(24px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-xl);
  font-weight: bold;
  padding-bottom: var(--sp-16);
  border-bottom: 1px solid
    ${(props) => props.theme.colors.borderColor || "#e0e0e0"};

  /*
   * Grudado no topo da gaveta. Numa gaveta que rola, o titulo e o X somem
   * assim que a pessoa desce dois campos — e sem o X visivel o unico jeito de
   * sair passa a ser rolar de volta ate' em cima.
   *
   * O fundo opaco e' obrigatorio: sem ele o conteudo passa POR TRAS do titulo
   * e as duas camadas de texto se sobrepoem.
   */
  ${ate.tablet} {
    position: sticky;
    top: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: calc(var(--sp-16) * -1) calc(var(--sp-16) * -1) 0;
    padding: var(--sp-16);
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  max-height: calc(var(--u) * 600);
  flex: 1;
  overflow: hidden;

  /*
   * TRES CONSERTOS NUMA REGRA SO', e o do meio e' o grave.
   *
   * 1. "flex-direction: row" poe as colunas lado a lado. Num telefone cada
   *    uma fica com metade de 375px, e o formulario vira uma coluna de
   *    palavras cortadas. Em coluna, cada bloco usa a largura toda.
   *
   * 2. "overflow: hidden" com altura limitada NAO ESCONDE: ELIMINA. O que
   *    passa do corte nao aparece e nao tem barra de rolagem para alcancar —
   *    num modal alto, os ultimos campos simplesmente nao existem para quem
   *    esta' no celular. O auto devolve a rolagem.
   *
   * 3. O teto de 600u e' desenho de tela grande. Na gaveta quem manda na
   *    altura e' a propria gaveta (92dvh), entao ele sai.
   */
  ${ate.tablet} {
    flex-direction: column;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
`;

export const ModalTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: var(--sp-12);
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.selection};
  font-size: var(--fs-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-8);
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.selection + "20"};
  }
`;

export const ModalFooter = styled.div`
  padding-top: var(--sp-20);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin-top: auto;

  /*
   * Grudado no pe' da gaveta, pelo mesmo motivo do cabecalho: sao os botoes de
   * Salvar e Cancelar. Um formulario longo empurrava os dois para fora da
   * area visivel, e a pessoa rolava sem saber que havia botao.
   *
   * Fundo opaco, sem transparencia: o rodape fica por cima de conteudo denso
   * (tabelas, listas), e translucido ali confunde em vez de enfeitar.
   */
  ${ate.tablet} {
    position: sticky;
    bottom: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: 0 calc(var(--sp-16) * -1) calc(var(--sp-16) * -1);
    padding: var(--sp-12) var(--sp-16)
      calc(var(--sp-12) + env(safe-area-inset-bottom, 0px));
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

// ===== COMPONENTES DE BOTÃO =====
export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--sp-12);
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  padding: var(--sp-12) var(--sp-24);
  background-color: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.selectionDark};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--fs-md);
  font-weight: 500;
  transition: background-color 0.2s, transform 0.2s;
  gap: var(--sp-8);

  &:hover {
    background-color: #e8e8e8;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// ===== COMPONENTES DE EMPRESA =====
export const CompanyContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: var(--sp-10);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
`;

export const CompanyTopContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const CompanyBottom = styled.div`
  display: flex;
  height: 50%;
  overflow: hidden;
`;

export const CompanyInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  padding: var(--sp-10);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  height: calc(var(--u) * 350);
`;

export const CompanyInfoList = styled.div`
  padding-right: var(--sp-10);
  border-right: 1px solid ${(props) => props.theme.colors.text};
  overflow-y: auto;
  padding: var(--sp-10);
  background-color: ${(props) => props.theme.colors.background};
  height: 100%;
  width: 25%;
`;

export const CompanyInfo = styled.div<{ selected: boolean }>`
  padding: var(--sp-10);
  margin-bottom: var(--sp-10);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--sp-10);
  border: 1px solid #000000;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  color: ${({ selected }) => (selected ? "#000000" : "inherit")};
  background: ${({ selected }) =>
    selected ? "rgba(255, 196, 0, 0.372)" : "inherit"};
  &:hover {
    color: "#000000";
    background: rgba(255, 196, 0, 0.372);
  }
`;

export const CompanyInfoContent = styled.div`
  flex: 1;
  padding: var(--sp-16);
  overflow-y: auto;
`;

// ===== COMPONENTES DE FORMULÁRIO =====
export const FormSection = styled.div`
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  padding: var(--sp-20);
  margin-bottom: var(--sp-16);
`;

export const FormRow = styled.div`
  display: flex;
  gap: var(--sp-16);
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const LabelInputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  align-self: start;
  font-weight: bold;
  color: ${(props) => props.theme.colors.label};
  position: relative;
  white-space: nowrap;

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-10%);
    top: 100%;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    cursor: help;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateX(-5%) translateY(-35px);
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: var(--sp-12);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 6px;
  font-size: var(--fs-md);
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.selection};
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.label};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// ===== COMPONENTES DE INFORMAÇÃO =====
export const InfoSection = styled.div`
  padding: 0;
  height: 100%;
  overflow-y: auto;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 250), 1fr));
  gap: var(--sp-16);
  margin-bottom: var(--sp-16);
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 250), 1fr));
  gap: var(--sp-16);
  margin-top: var(--sp-16);
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  padding: var(--sp-16);
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.label};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: calc(var(--u) * 0.5);
`;

export const InfoValue = styled.div<{ status?: boolean }>`
  font-size: var(--fs-md);
  font-weight: 600;
  color: ${(props) =>
    props.status === undefined
      ? props.theme.colors.text
      : props.status
      ? "#4CAF50"
      : "#F44336"};
`;

// ===== COMPONENTES DE ALERTA =====
export const AlertMessage = styled.div<{
  type: "info" | "warning" | "error" | "success";
}>`
  display: flex;
  align-items: flex-start;
  gap: var(--sp-12);
  padding: var(--sp-16);
  border-radius: 8px;
  background-color: ${(props) => {
    switch (props.type) {
      case "info":
        return "#E3F2FD";
      case "warning":
        return "#FFF3E0";
      case "error":
        return "#FFEBEE";
      case "success":
        return "#E8F5E8";
      default:
        return "#E3F2FD";
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case "info":
        return "#1565C0";
      case "warning":
        return "#E65100";
      case "error":
        return "#C62828";
      case "success":
        return "#2E7D32";
      default:
        return "#1565C0";
    }
  }};
  border-left: 4px solid
    ${(props) => {
      switch (props.type) {
        case "info":
          return "#2196F3";
        case "warning":
          return "#FF9800";
        case "error":
          return "#F44336";
        case "success":
          return "#4CAF50";
        default:
          return "#2196F3";
      }
    }};
  margin: var(--sp-16) 0;

  .material-icons {
    font-size: var(--fs-2xl);
    flex-shrink: 0;
  }

  div {
    flex: 1;

    strong {
      display: block;
      margin-bottom: var(--sp-4);
    }
  }
`;

// ===== COMPONENTES DE ÍCONES =====
export const MaterialIcons = styled.span`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: var(--fs-xl);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const StyledIcon = styled.div`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: var(--fs-xl);
`;

// ===== COMPONENTES DE TÍTULO =====
export const SectionTitle = styled.h3`
  font-size: var(--fs-xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0 0 var(--sp-16) 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

// ===== COMPONENTES DE TEXTAREA =====
export const TextArea = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};

  textarea {
    width: 100%;
    padding: var(--sp-12);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 8px;
    outline: none;
    background: ${(props) => props.theme.colors.selection + "20"};
    resize: vertical;
    font-family: inherit;
    font-size: var(--fs-md);
    transition: all 0.2s ease;

    &:focus {
      background-color: ${(props) =>
        (props.theme.colors.primary || props.theme.colors.selection) + "20"};
      border-color: ${(props) => props.theme.colors.selection};
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
    }
  }

  label {
    position: absolute;
    top: calc(var(--u) * -8);
    left: calc(var(--u) * 12);
    background: ${(props) => props.theme.colors.modalColor};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-8);
    font-size: var(--fs-xs);
    font-weight: 600;
  }
`;

// Exportação padrão para compatibilidade
export default {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  SecondaryButton,
  PrimaryButton,
  MaterialIcons,
  CompanyContainer,
  CompanyTopContainer,
  CompanyBottom,
  CompanyInfoContainer,
  CompanyInfoList,
  CompanyInfo,
  CompanyInfoContent,
  FormSection,
  SectionTitle,
  FormRow,
  LabelInputContainer,
  Label,
  Input,
  InfoGrid,
  InfoItem,
  InfoLabel,
  InfoValue,
  StyledIcon,
  InfoSection,
  FormGrid,
  TextArea,
  AlertMessage,
};
